import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import produce from 'immer';
export const RECOMMENDATIONS_LOCALSTORAGE_KEY = 'academy:recommendations';
export const useRecommendationsState = create()(persist(set => ({
  lastClickedRecommendationItem: null,
  setLastClickedRecommendationItem: recommendation => set(produce(state => {
    state.lastClickedRecommendationItem = recommendation;
  })),
  clearLastClickedRecommendationItem: () => set(produce(state => {
    state.lastClickedRecommendationItem = null;
  }))
}), {
  name: RECOMMENDATIONS_LOCALSTORAGE_KEY
}));